import React from 'react'

export const NameHeader = () => {
  return (
    <div>
    <div style={{ textAlign:"center", fontSize:"50px", marginTop:20}}>VISHWAJEET DESHMUKH</div> 
    <hr />
    </div>
  )
}